module.exports = __webpack_public_path__ + "img/completion1.9da00f7f.svg";